export const getLogin = (state) => state;
